import React from "react";
import { useAppSelector } from "store";

import { Box, Grid, GridSize } from "@material-ui/core";

import { selectIsInsightExpanded } from "modules/customer/tools/location/locationSlice";

import NearbyCompetitionTable from "./NearbyCompetitionTable";
import NumberOfCompetitors from "./NumberOfCompetitors";
import NumberOfDirectCompetitors from "./NumberOfDirectCompetitors";
import NumberOfIndirectCompetitors from "./NumberOfIndirectCompetitors";

const NearbyCompetitorStores: React.FC = () => {
    const isInsightExpanded = useAppSelector(selectIsInsightExpanded);
    const kpiGridSize: GridSize = isInsightExpanded ? 6 : 12;

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={kpiGridSize}>
                    <NumberOfDirectCompetitors />
                </Grid>
                <Grid item xs={kpiGridSize}>
                    <NumberOfCompetitors />
                </Grid>
                <Grid item xs={kpiGridSize}>
                    <NumberOfIndirectCompetitors />
                </Grid>
                <Grid item xs={kpiGridSize} style={{ minWidth: '100%' }}>
                    <Box display="flex" flexDirection="column" width="100%">
                        <Box flexGrow={1} width="100%" height={'60vh'}>
                            <NearbyCompetitionTable />
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default NearbyCompetitorStores;
